import { Toast, toast } from '@heroui/react'

/** How long a staff toast stays: a few seconds. */
export const TOAST_MS = 3500

export type ToastKind = 'success' | 'warning' | 'danger'

/** A staff toast (six words or fewer) in the one HeroUI region StaffToasts mounts. */
export function showToast(text: string, kind: ToastKind = 'success', timeout = TOAST_MS, onClose?: () => void): string {
  return toast[kind](text, { timeout, onClose })
}

export function closeToast(key: string): void {
  toast.close(key)
}

/** The toast region, mounted once in App.tsx; no hotkey (no keyboard shortcuts). */
export function StaffToasts() {
  return <Toast.Provider placement="bottom end" width={360} hotkey={[]} />
}
